module.exports = __webpack_public_path__ + "static/img/female-bg-fr.96811816.png";